import { Box } from '@material-ui/core';
import React, { useEffect } from 'react';

const loadScript = (src: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        document.head.appendChild(script);
    });
};

const ReferAClient: React.FC = () => {
    useEffect(() => {
        const initializeTripetto = () => {
            if ((window as any).TripettoStudio && (window as any).FluxClassic) {
                (window as any).TripettoStudio.form({
                    runner: (window as any).FluxClassic,
                    token: process.env.NEXT_PUBLIC_FLUX_TOKEN,
                    url: process.env.NEXT_PUBLIC_FLUX_URL,
                    filestoreUrl: process.env.NEXT_PUBLIC_FLUX_FILESTORE_URL,
                    element: 'tripetto-1mob3fc',
                });
            }
        };

        const loadScriptsAndInitialize = async () => {
            try {
                await loadScript('https://stag.fluxpro.tech/js/tripetto-runner.js');
                await loadScript('https://stag.fluxpro.tech/js/tripetto-studio.js');
                await loadScript('https://stag.fluxpro.tech/js/classic/runner.js');
                initializeTripetto();
            } catch (error) {
                throw Error('Error loading Flux form');
            }
        };

        loadScriptsAndInitialize();
    }, []);

    return (
        <Box mt="3.125rem" minWidth="50vw">
            <div id="tripetto-1mob3fc"></div>
        </Box>
    );
};

export default ReferAClient;
